import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TaskViewContextType {
  isInTaskView: boolean;
  setIsInTaskView: (inTask: boolean) => void;
  currentTaskTitle: string | null;
  setCurrentTaskTitle: (title: string | null) => void;
}

const TaskViewContext = createContext<TaskViewContextType | undefined>(undefined);

export const TaskViewProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isInTaskView, setIsInTaskView] = useState(false);
  const [currentTaskTitle, setCurrentTaskTitle] = useState<string | null>(null);

  return (
    <TaskViewContext.Provider value={{ 
      isInTaskView, 
      setIsInTaskView, 
      currentTaskTitle, 
      setCurrentTaskTitle 
    }}>
      {children}
    </TaskViewContext.Provider>
  );
};

export const useTaskView = () => {
  const context = useContext(TaskViewContext);
  if (context === undefined) {
    throw new Error('useTaskView must be used within a TaskViewProvider');
  }
  return context;
};
